// IMPORT
import React from "react";
import { Link } from "react-router-dom";

// CSS
import './CompPictureTextBottom.css'

// CompPictureTextBottom
export default function CompPictureTextBottom(props) {
    return (
        <Link className="CompPictureTextBottom-Container" to={props.Link}>
            <div className="CompPictureTextBottom-Container-Top">
                <img src={props.Graphic} alt={props.GraphicAlt} />
            </div>
            <div className="CompPictureTextBottom-Container-Bottom">
                <div className="CompPictureTextBottom-Container-Bottom-Title">
                    <h2>{props.Title}</h2>
                    <h3>{props.Subheading}</h3>
                </div>
                <div className="CompPictureTextBottom-Container-Bottom-Text">
                    <p>{props.Text}</p>
                </div>
            </div>
        </Link>
    )
}
